<template>
  <a-modal :bodyStyle="{lineHeight:0}" v-model="visible" :footer="null" class="demo-video" centered :afterClose="close" :maskClosable="false" :destroyOnClose="true" key="demo-video" :width="width">
    <a-icon type="close-circle" @click="visible=false" v-show="visible" />
    <video controls :src="url" autoplay="autoplay">
      <source :src="url" type="video/mp4" />
    </video>
  </a-modal>
</template>
<script>
export default {
  data() {
    return {
      visible: true,
      width: document.body.offsetWidth
    };
  },
  props: {
    close: Function,
    url: String
  }
};
</script>
<style lang="scss" >
@import "~@/components/layout/style/mixin.scss";

.ant-modal-close-x {
  display: none;
}
.demo-video > .ant-modal-content {
  background-color: transparent !important;
  text-align: center !important;
  .anticon-close-circle {
    color: #333;
    position: fixed;
    top: 50px;
    right: 20px;
    font-size: 50px;
  }
}
.demo-video {
  .ant-modal-content,
  & >>> .ant-modal-content,
  & /deep/ .ant-modal-content {
    background: transparent;
    text-align: center;
  }
  & /deep/ .anticon-close-circle {
    color: #333;
    position: fixed;
    top: 50px;
    right: 20px;
    font-size: 50px;
  }
  & /deep/ .ant-modal-body {
    padding: 0;
  }
}
</style>
